import { useMutation } from "react-query";
import { PoolingReview } from "../services/StructureNote";

function usePoolingReview() {
  return useMutation(["review"], PoolingReview);
}

export default usePoolingReview;